import ThemeComponent from "./theme/ThemeComponent";
import { SettingsProvider, SettingsConsumer, Settings } from "./context/settingsContext";

interface ThemeWrapperProps {
  children: React.ReactNode;
  exteriorContextSettings?: Settings;
}

const ThemeWrapper = ({ children, exteriorContextSettings }: ThemeWrapperProps) => {
  return (
    <SettingsProvider>
      <SettingsConsumer>
        {({ settings }) => {
          return <ThemeComponent settings={exteriorContextSettings ? exteriorContextSettings : settings}>{children}</ThemeComponent>;
        }}
      </SettingsConsumer>
    </SettingsProvider>
  );
};

export default ThemeWrapper;
